import React, { useEffect } from "react";
import "@elastic/eui/dist/eui_theme_light.css";
import {
  EuiProvider,
  EuiPage,
  EuiPageHeader,
  EuiPageSidebar,
  EuiPageBody,
  EuiPageSection,
} from "@elastic/eui";

import { Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiUrl } from "./utils/api";

import HeaderUserMenu from "./components/HeaderUserMenu";
import PageHeader from "./components/PageHeader";
import PageNav from "./components/PageNav";
import RegisterForm from "./forms/RegisterForm";
import LoginForm from "./forms/LoginForm";
import LoginPage from "./pages/LoginPage";
import CourseListPage from "./pages/CourseListPage";
import FileManagePage from "./pages/FileManagePage";
import ChatPage from "./pages/ChatPage.jsx"; // import from renamed component file
import ModernHomePage from "./pages/ModernHomePage";
import StudentDashboard from "./pages/StudentDashboard";
import { UserProvider } from "./Context";
import StatisticPage from "./pages/StatisticPage";
import InstructorReviewPage from "./pages/InstructorReviewPage";
import { useParams } from "react-router-dom";
import TeacherDashboard from "./pages/TeacherDashboard.jsx";

// Wrapper component to force ClaudePage re-mount when course or workspace mode changes
const ChatPageWrapper = () => {
  const { courseNumber, courseName } = useParams();
  // Always use full pathname as key to ensure re-mount when switching between practice/study/chat
  const key = window.location.pathname;
  return <ChatPage key={key} />;
};

const App = () => {
  // const [loginState, setLoginState] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Ensure axios sends cookies in dev when using CRA proxy to backend
    axios.defaults.withCredentials = true;
    axios
      .post(getApiUrl("/api/userinfo"), {})
      .then((response) => {
        const role = response.data.role;
        // optional role-based navigation can be re-enabled here
      })
      .catch(() => {
        // silently ignore if not logged in
      });
  }, []);

  return (
    <EuiProvider colorMode="light">
      <UserProvider>
        <Routes>
          <Route exact path="/" element={<ModernHomePage />} />
          <Route path="/auth" element={<ModernHomePage />} />

          {/* Student Routes */}
          <Route path="/student" element={<StudentDashboard />} />
          <Route path="/student/practice" element={<ChatPageWrapper />} />
          <Route path="/student/study" element={<ChatPageWrapper />} />
          <Route
            path="/sessions/:courseNumber/:courseName"
            element={<ChatPageWrapper />}
          />

          {/* Teacher/Admin Routes */}
          <Route
            path="*"
            element={
              <EuiPage paddingSize="none">
                {/* <EuiPageSidebar paddingSize="none" sticky minWidth={"0"}>
                  <PageNav />
                </EuiPageSidebar> */}
                <EuiPageBody paddingSize="none">
                  {/* <EuiPageHeader paddingSize="none">
                    <EuiPageSection>
                      <PageHeader />
                    </EuiPageSection>
                  </EuiPageHeader> */}
                  <EuiPageSection>
                    <Routes>
                      <Route path="/courses" element={<CourseListPage />} />
                      <Route
                        path="/statistic/:courseNumber/:courseName"
                        element={<StatisticPage />}
                      />
                      <Route
                        path="/instructor/review/:courseNumber/:courseName"
                        element={<InstructorReviewPage />}
                      />
                      <Route
                        path="/teachers-dashboard/:courseNumber/:courseName"
                        element={<TeacherDashboard />}
                      />
                    </Routes>
                  </EuiPageSection>
                </EuiPageBody>
              </EuiPage>
            }
          />
        </Routes>
      </UserProvider>
    </EuiProvider>
  );
};
export default App;
